import VideoParticipant from './VideoParticipant/VideoParticipant';

export const getMainParticipant = (participants, memberConnectionId, room, setEnableAudio, memberFullName) => {
    if (participants.length === 0) {
        return <></>;
    }

    const member = participants.find(
        (participant) =>
            participant.identity === memberConnectionId || participant.identity.startsWith(memberFullName),
    );

    return member ? (
        <VideoParticipant
            key={member.sid}
            participant={member}
            room={room}
            setEnableAudio={setEnableAudio}
        />
    ) : (
        <></>
    );
};
